export default "__VITE_ASSET__CXasMO5r__"